const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 800 811"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB w36 ` + (props.className || '')}
    >
      <path
        d="M618.3,430.1c1.1,121.1,106.2,161.4,107.4,161.9c-0.9,2.8-16.8,57.4-55.4,113.8c-33.3,48.7-68,97.3-122.5,98.3
	c-53.6,1-70.8-31.8-132-31.8c-61.2,0-80.4,30.8-131.1,32.8c-52.6,2-92.7-52.7-126.3-101.3c-68.7-99.3-121.2-280.7-50.7-403.1
	c35-60.8,97.6-99.3,165.5-100.3c51.7-1,100.4,34.8,132,34.8c31.6,0,90.8-43,153.1-36.7c26.1,1.1,99.3,10.5,146.3,79.4
	C701,280.3,617.4,328.9,618.3,430.1 M517.7,132.8C545.6,99,564.4,52,559.3,5.1c-40.3,1.6-89,26.8-117.8,60.6
	c-25.9,29.9-48.6,77.8-42.4,123.7C443.9,193,489.7,166.7,517.7,132.8"
        stroke="#fff"
        strokeWidth="20"
        fill="#000"
      />
    </svg>
  );
};
